import React from "react";
import "./loader.css";

export const Loader = () => {
    return (
        <div className="loader-page">
            <div className="loader"></div>
            <div className="loader-text">We are processing your request. Please wait..</div>
        </div>
    );
};
